<template>
  <div class="choose-staff">
    <Input search :value="searchKeyword" @on-search="onSearch" placeholder="员工名称搜索"></Input>
    <!--<Button @click="setCheckedNodes">设置员工</Button>-->
    <!--<div class="personnel-content">-->
      <template v-if="!data.length">
        <p style="text-align: center;padding-top: 40px;">未找到“{{ searchKeyword }}”相关内容</p>
      </template>
      <template v-else>
        <Scroll :height="340" :on-reach-bottom="handleReachBottom">
          <node v-for="(node, index) in data" :node="node" :props="defaultProps" @on-change="handleNodeChange" :multiple="multiple" :key="index"></node>
        </Scroll>
      </template>
    <!--</div>-->
  </div>
</template>

<script>
import mixin from "../mixin";
import Store from "../store";
import { getStaff } from "@/api/components";
import node from "./node";
export default {
  name: "staff",
  mixins: [mixin],
  created() {
    this.getAjaxData();
    this.store = new Store();
    this.data = this.store.root;
  },
  mounted() {
    this.store.setCheckedNodes(this.checkedData);
  },
  data() {
    return {
      store: null,
      searchKeyword: "",
      currentPage: 1,
      totalPage: 0,
      data: [],
      checkedData: [],
      defaultProps: {
        desc: "positionName"
      }
    };
  },
  methods: {
    handleNodeChange(nodeData, checked) {
      if (checked) {
        if (!this.checkedData.length) {
          this.checkedData.push(nodeData);
        } else {
          let checkedIds = this.checkedData.map(item => item.id);
          let _index = checkedIds.indexOf(nodeData.id);
          if (_index > -1) {
            this.checkedData.splice(_index, 1, nodeData);
          } else {
            this.checkedData.push(nodeData);
          }
        }
      } else {
        this.del(nodeData);
      }
      this.$emit("on-change", this.checkedData);
    },
    setCheckedNodes() {
      // this.store.setCheckedNodes([
      //   { id: "123", name: "a" },
      //   { id: "119", name: "b" },
      //   { id: "118", name: "c" },
      //   { id: "113", name: "d" }
      // ]);
      // console.log(this.store.getCheckedNodes());
    },
    getAjaxData(page = 1) {
      getStaff({
        user_type: 1,
        not_ids: this.excludeId.join(","),
        ids: this.includeId.join(","),
        page,
        search_name: this.searchKeyword
      })
        .then(res => {
          this.totalPage = res.pageCount;
          this.formatAjaxData(res.data);
        })
        .catch(err => {
          const { status } = err;
          if (status === "002") {
            this.store.clear();
          }
        });
    },
    del(node) {
      this.checkedData.forEach((item, index) => {
        if (item.id === node.id) {
          this.checkedData.splice(index, 1);
        }
      });
      this.store.setCheckedNodes(this.checkedData);
    },
    onSearch(value) {
      value = value.trim();
      if (this.searchKeyword !== value) {
        this.searchKeyword = value;
        this.currentPage = 1;
        this.store.clear();
        this.getAjaxData();
      }
    },
    formatAjaxData(ajaxData) {
      let _ajaxData = [];
      ajaxData.forEach(item => {
        _ajaxData.push({
          id: item.id,
          name: item.name,
          positionName: item.duty_name
        });
      });
      this.store.append(_ajaxData);
      this.store.setCheckedNodes(this.checkedData);
    },
    handleReachBottom() {
      this.currentPage++;
      if (this.currentPage > this.totalPage) {
        this.currentPage = this.totalPage;
        return;
      }
      this.getAjaxData(this.currentPage);
    }
  },
  components: {
    node
  },
  watch: {
    includeId() {
      this.store.clear();
      this.getAjaxData();
    },
    checked: {
      handler() {
        this.checkedData = JSON.parse(JSON.stringify(this.checked));
        this.store.setCheckedNodes(this.checked);
      },
      deep: true
    }
  }
};
</script>

<style scoped lang="less">

</style>
